import { AHInput, AHText, Box, Card, useTheme } from "arkh";
import { ColorSelect, ColorSelectItem } from "./ColorSelect";
import React, { useCallback, useState } from "react";

import { useIntl } from "react-intl";

import { TodoCategoryTagCreateScreenMutation } from "./__generated__/TodoCategoryTagCreateScreenMutation.graphql";
import { graphql, useMutation } from "react-relay";
import { StoreAdminNavigationScreenProps } from "../StoreAdmin/StoreAdminNavigation";
import { useNavigationHeader } from "@/src/common/navigationHeaderOptions";
import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { KeyboardAwareScrollView } from "react-native-keyboard-controller";

type TodoCategoryTagCreateScreenProps =
  StoreAdminNavigationScreenProps<"TodoCategoryTagCreate">;

export function TodoCategoryTagCreateScreen({
  route: { params },
  navigation,
}: TodoCategoryTagCreateScreenProps) {
  const [title, setTitle] = useState("");
  const theme = useTheme();
  const [color, setColor] = useState<string>(theme.colorScheme[0]);

  const intl = useIntl();

  const [createTag, loading] = useMutation<TodoCategoryTagCreateScreenMutation>(
    graphql`
      mutation TodoCategoryTagCreateScreenMutation(
        $id: ID!
        $input: TagCreateInput!
      ) {
        todoCategory(id: $id) {
          tagCreate(input: $input) {
            todoCategory {
              id
              tags {
                id
                title
                color
              }
            }
          }
        }
      }
    `
  );

  const onCreateTag = useCallback(() => {
    createTag({
      variables: {
        id: params.categoryId,
        input: {
          title,
          color: color as string,
        },
      },
      onCompleted: navigation.goBack,
    });
  }, [createTag, params.categoryId, title, color, navigation.goBack]);

  useNavigationHeader({
    type: "CREATE",
    onCancel: () => navigation.goBack(),
    onSave: onCreateTag,
    saveLoading: loading,
  });

  const intl_tokens = useIntlTokens();

  return (
    <KeyboardAwareScrollView
      contentInsetAdjustmentBehavior="automatic"
      keyboardShouldPersistTaps="handled"
    >
      <Box
        space="medium"
        style={{
          flex: 1,
        }}
      >
        <Box spaceBottom="large">
          <AHText type="title-small" spaceBottom="small" spaceLeft="xsmall">
            {intl_tokens.Name}
          </AHText>
          <Box
            style={{
              flexDirection: "row",
              alignItems: "center",
              borderWidth: 1,
            }}
            spaceLeft="medium"
            color="surface"
            cornerRadius="large"
            borderColor="border-primary"
          >
            <ColorSelectItem color={color} selected={false} />
            <AHInput
              placeholder={intl.formatMessage({
                defaultMessage: "Tag title",
                description: "tag title input placeholder",
              })}
              textType="list-item-title"
              defaultStyle
              autoFocus
              style={{ flex: 1, borderWidth: 0 }}
              value={title}
              onChangeText={setTitle}
            />
          </Box>
        </Box>
        <AHText type="title-small" spaceBottom="small" spaceLeft="xsmall">
          {intl_tokens.Color}
        </AHText>
        <Card defaultBorder>
          <ColorSelect selected={color} setSelected={setColor} />
        </Card>
      </Box>
    </KeyboardAwareScrollView>
  );
}
